/**
 * /app — parent layout for every authenticated route under /app/*.
 *
 * beforeLoad gates access on a Supabase session. No session → redirect
 * to /sign-in?redirect=<current> so the user lands back here after
 * the magic-link round-trip.
 *
 * If you're signed in and hit /app directly (index), bounce to
 * /app/profile (the one app screen that's currently real). Once the
 * onboarding wizard lands and orgs exist, replace the index redirect
 * with the dashboard route per Section 3 of the Phase 2 spec.
 */
import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { supabase, SUPABASE_CONFIGURED } from '@/lib/supabase';

export const Route = createFileRoute('/app')({
  beforeLoad: async ({ location }) => {
    // Without a configured backend, let the user through to a
    // "backend not configured" screen rather than redirecting to a
    // sign-in form that will also fail. The /app/profile route surfaces
    // the config problem.
    if (!SUPABASE_CONFIGURED) return;

    const {
      data: { session },
    } = await supabase.auth.getSession();
    if (!session) {
      throw redirect({
        to: '/sign-in',
        search: { redirect: location.href },
      });
    }
  },
  component: AppLayout,
});

function AppLayout() {
  return <Outlet />;
}
